import "./PartOfTitleHome.scss";
import { useNavigate } from "react-router-dom";
import Button from "../../../DesingSystem/Button/Button";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';


function PartOfTitleHome() {
  const navigate = useNavigate();
  const goToLogin = () => {
    navigate("/login");
  };
  const { t } = useTranslation();
  

  return (
    <section className="part-title-home">
      <div className="part-title-home__container-bg">
        <p className="part-title-home__title">
          <Trans i18nKey="heroTitle">
            Llega más lejos con <i>Bookólicos</i>
          </Trans>
        </p>
        <p className="part-title-home__subtitle">
          <Trans i18nKey="heroSubTitle">
            La plataforma que ayuda a autores a conseguir su propio estilo y
            ofrece historias de calidad a lectores.
          </Trans>
        </p>
        <div className="part-title-home__buttons">
          <div className="part-title-home__buttons-item-one">
            <Button
              className="btn-blackbg big"
              text={<Trans i18nKey="startWritting">Empieza a escribir</Trans>}
              onClick={goToLogin}
            />
          </div>
          <div className="part-title-home__buttons-item-two">
            <Button
              className="btn-blackbg big"
              text={<Trans i18nKey="startReading">Empieza a leer</Trans>}
              onClick={goToLogin}
            />
          </div>
        </div>{" "}
      </div>
    </section>
  );
}

export default PartOfTitleHome;
